import { LoadingBar, Modal, ModalBottomButtons } from '@bp/ui-components';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useTimetableStore } from '../TimetableProvider';
import { GenerateForm } from './GenerateForm';
import styles from './GenerateModal.module.scss';

export const GenerateModal: FC = observer(() => {
  const { t } = useTranslation();
  const pinboardStore = useTimetableStore();

  const job = pinboardStore.mathplanJob;
  const jobRunning = pinboardStore.jobRunning;
  return (
    <Modal
      hideCloseButton={true}
      title={t('pinboard.generate.title')}
      isOpen={pinboardStore.generateModalOpen}
      onRequestClose={() => pinboardStore.setGenerateModalOpen(false)}
    >
      {!job && <GenerateForm />}
      {jobRunning && <LoadingBar progress={job?.progress ?? 0} height={'l'} />}
      <ModalBottomButtons
        isLoading={jobRunning}
        closeButton={{
          disabled: job?.status !== 'RUNNING',
          callback: async () => {
            await pinboardStore.abortJob();
            pinboardStore.setGenerateModalOpen(false);
          },
        }}
        submitButton={{
          disabled: jobRunning,
          callback: () => pinboardStore.generate(),
          text: t('pinboard.generate.start'),
        }}
      />
    </Modal>
  );
});
